import { render, staticRenderFns } from "./RemoveImage.vue?vue&type=template&id=3ad1d4f7"
import script from "@/scripts/modal/rentalService/removeImage.js?vue&type=script&lang=js&external"
export * from "@/scripts/modal/rentalService/removeImage.js?vue&type=script&lang=js&external"
import style0 from "./RemoveImage.vue?vue&type=style&index=0&id=3ad1d4f7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports